module.exports = __webpack_public_path__ + "static/images/callout_3.6f318d00f33f99e115f4c6226d971a69.jpg";